import React, { useState, useEffect } from 'react';

const PagePreview = ({ page, pageIndex, renderPreview }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const loadPreview = async () => {
      if (!page) {
        setLoading(false);
        return;
      }

      setLoading(true);
      const url = await renderPreview(page.originalIndex, page.rotation);
      
      if (mounted) {
        setPreviewUrl(url);
        setLoading(false);
      }
    };

    loadPreview();

    return () => {
      mounted = false;
    };
  }, [page, pageIndex, renderPreview]);

  if (loading) {
    return (
      <div className="ds-page-preview">
        <div className="ds-page-preview-loading">
          <div className="ds-spinner" />
          <p>Loading preview...</p>
        </div>
      </div>
    );
  }

  if (!previewUrl) {
    return (
      <div className="ds-page-preview">
        <div className="ds-page-preview-error">
          <p>Failed to load preview</p>
        </div>
      </div>
    );
  }

  return (
    <div className="ds-page-preview">
      <div className="ds-page-preview-header">
        <span className="ds-page-preview-title">Page {pageIndex + 1}</span>
        {page.deleted && (
          <span className="ds-page-preview-badge ds-page-preview-badge--deleted">
            Marked for deletion
          </span>
        )}
        {page.rotation !== 0 && (
          <span className="ds-page-preview-badge ds-page-preview-badge--rotated">
            Rotated {page.rotation}°
          </span>
        )}
        {page.annotation && (
          <span className="ds-page-preview-badge ds-page-preview-badge--annotated">
            {page.annotation}
          </span>
        )}
      </div>
      <div className="ds-page-preview-content">
        <img
          src={previewUrl}
          alt={`Page ${pageIndex + 1} preview`}
          className="ds-page-preview-image"
        />
      </div>
    </div>
  );
};

export default PagePreview;
